import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import SelectedUserMobile from './SelectedUserMobile';
import UserChip from './UserChip';
import type { NotifyUser } from '../types';

interface UsersListProps {
  selectedUsers: NotifyUser[];
  isMobile: boolean;
  removeUser: (user: NotifyUser) => void;
  hasWarning: boolean;
}

export const UsersList = ({
  selectedUsers,
  isMobile,
  removeUser,
  hasWarning,
}: UsersListProps) => {
  if (isMobile) {
    return (
      <Box flexDirection="column" overflow="auto" mt={2}>
        {selectedUsers?.map((user) => (
          <SelectedUserMobile
            key={user.id}
            user={user}
            removeUser={removeUser}
          />
        ))}
      </Box>
    );
  }

  return (
    <UserChipWrapper
      data-testid="notify-selected-users"
      mt={hasWarning ? 1 : 3}
    >
      {selectedUsers?.map((user) => (
        <UserChip key={user.id} user={user} onRemove={removeUser} />
      ))}
    </UserChipWrapper>
  );
};

const UserChipWrapper = styled(Box).attrs({
  flexWrap: 'wrap',
  maxHeight: '94px',
  overflow: 'auto',
  p: '2px',
})`
  border: ${({ theme }) => `1px solid ${theme.colors.black}`};
  border-radius: 5px;
`;
